import { render, staticRenderFns } from "./CorporationConfig.vue?vue&type=template&id=fb3e75b6"
import script from "./CorporationConfig.vue?vue&type=script&lang=js"
export * from "./CorporationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports